var _style, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndependenceGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 85 85",
    style: {
      enableBackground: "new 0 0 85 85"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CCCCCC;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 42.5,
    cy: 42.5,
    r: 42.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.8,24.9l-3.9,2.7c-3.4,2.2-7,0.9-10.9-0.4c-2.8-1-5.6-2-8.5-1.6c-2.7,0.2-4.3,0.9-5.4,1.5 c0-0.3,0.1-0.7,0.1-1c-0.2-2.6-2.1-4.5-4.8-4.5c-0.3,0-0.6,0-0.9,0.1c-2.4,0.3-4.1,2.5-4,5.2c0.1,1.9,1.1,3.3,2.6,4.1 c-0.5,0.7-0.7,1.6-0.6,2.5l4.5,36c0.3,2,1.9,3.5,3.8,3.5c1,0,2-0.4,2.7-1.2c0.8-0.9,1.1-2.2,1-3.6l-2.3-18.3 c0.3-0.2,0.6-0.5,0.9-0.7c0.3-0.3,0.7-0.5,1-0.7c4-2,7.8-1,11.8,0.1c4.9,1.4,10,2.8,15.7-1.8l0.4-0.4L63.8,24.9z M29.8,23.6 c0.2,0,0.4,0,0.6,0c3.7,0,3.5,4.9,0.9,5.7c-0.1,0-0.1,0-0.2,0c-0.3,0-0.7,0.1-1,0.1C26.7,29.2,26.7,23.9,29.8,23.6z M35.8,70.9 c-0.8,0-1.6-0.6-1.8-1.7l-4.6-36.1c-0.1-0.8,0.4-1.4,1-1.7c0.2,0,0.4,0,0.6,0c0.1,0,0.2-0.1,0.3-0.1c0.6,0.1,1.2,0.5,1.5,1.4 l0.5,3.7l4.1,31.9C37.7,70.1,36.8,70.9,35.8,70.9z M51.4,46.5c-2.4-0.7-4.8-1.3-7.4-1.3c-1.9,0-3.9,0.4-5.9,1.4 c-0.4,0.2-0.8,0.5-1.1,0.8l-1.6-11.2l-0.4-3c0-0.3-0.1-0.6-0.2-0.9l-0.3-2.2c0.2-0.1,0.4-0.3,0.6-0.5c0.9-0.7,2-1.8,5.6-2 c2.4-0.3,4.9,0.6,7.6,1.5c4.1,1.4,8.4,2.9,12.6,0.2l1.2-0.9l2.6,17.1C60.2,49,55.9,47.8,51.4,46.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndependenceGrey);
export default __webpack_public_path__ + "static/media/IndependenceGrey.30c79047f80937af45a407440306dc4e.svg";
export { ForwardRef as ReactComponent };